import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';
import { formatNumber } from '../../../../../Common/FormatNumber';

interface ChartProps {
  title: string;
  height: number;
}

const ProductDrops: React.FC<ChartProps> = ({ title, height = 345 }) => {
  const [categories, setCategories] = React.useState([]);
  const [currentYear, setCurrentYear] = React.useState([]);
  const [previousYear, setPreviousYear] = React.useState([]);
  
  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    fetch(`/dashboard/product-drops/?entity_id=${localStorage.getItem('entity_id')}`)
      .then(response => response.json())
      .then(data => 
        setTimeout(() => {
          setCategories(data.categories);
          setCurrentYear(data.current_year);
          setPreviousYear(data.previous_year);
        }, 100)
      );

    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options: Highcharts.Options = {
        chart: {
            type: 'column',
            zooming: {
                type: 'xy' as const
            }
        },
        title: {
            text: title,
            align: 'left'
        },
        
        xAxis: {
            crosshair: true,
            accessibility: {
                description: ''
            },
            // minRange: 10,
            categories: categories,
            labels: {
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            title: {
                text: 'Products',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Sales ($)'
            },
            labels: {
                formatter: function(this: Highcharts.AxisLabelsFormatterContextObject) {
                    const v = this.value as number;
                    const absv = Math.abs(v);
                    if (absv >= 1000000) return v / 1000000 + 'M';
                    if (absv >= 1000) return v / 1000 + 'K';
                    return String(v);
                },
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },
        tooltip: {
            valueSuffix: ' ($)',
            formatter: function(this: Highcharts.Point) {
                return `<span style="font-family: Trebuchet MS;">${this.series.name}: ${formatNumber(this.y, 'en-US', 'USD')}</span>`;
            },
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                type: 'column',
                name: 'Current Year Sales',
                data: currentYear
            },
            {
                type: 'column',
                name: 'Previous Year Sales',
                data: previousYear
            }
        ]
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100%', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
        </div>
    );
};

export default ProductDrops;
